/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getLastSuccessfulLogin} from '../api'

 export const useQueryGetLastSuccessfulLogin = createReactQueryHook('getLastSuccessfulLogin', getLastSuccessfulLogin)
